// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3AgMO","productName":"Table_productName__c0OpY"};